import Button from '@/common/components/Button'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { formatDateTime } from '@/common/utils/formatters'
import { solicitationKindTranslation } from '@/features/maintenanceSolicitations/constants/solicitationKind.constant'
import { solicitationStatusTranslation } from '@/features/maintenanceSolicitations/constants/solicitationStatus.constant'
import {
  MaintenanceSolicitationData,
  MaintenanceSolicitationTableItem,
} from '@/features/maintenanceSolicitations/types/maintenanceSolicitation'
import { ArrowBigRight, CarIcon, User2Icon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class MaintenanceSolicitationsTransformer {
  static tableTransformer() {
    return (solicitations: MaintenanceSolicitationData[]): MaintenanceSolicitationTableItem[] => {
      return solicitations.map((solicitation) => {
        return {
          id: solicitation.id,
          status:
            solicitationStatusTranslation[solicitation.status as keyof typeof solicitationStatusTranslation] ||
            solicitation.status,
          equipment: (
            <ImageWithDisplayName
              imageUrl={solicitation?.photos?.[0]?.url || ''}
              displayName={solicitation.equipment?.field_for_display_value || ''}
              placeholderIcon={CarIcon}
            />
          ),
          author: solicitation.creator ? (
            <ImageWithDisplayName
              imageUrl={solicitation.creator?.profile_picture?.url || ''}
              displayName={solicitation.creator.full_name}
              placeholderIcon={User2Icon}
            />
          ) : (
            ''
          ),
          kind:
            solicitationKindTranslation[solicitation.kind as keyof typeof solicitationKindTranslation] ||
            solicitation.kind,
          observations: solicitation.observations,
          maintenance_program: '',
          rule_reached: '',
          created_at: formatDateTime(new Date(solicitation.created_at)),
          action: (
            <Link to={`/maintenance-solicitations/${solicitation.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Client::Maintenance::Solicitations::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
